import { ArrowDownRight, ArrowUpRight } from "lucide-react";

import { formatScorecardDrift } from "../../utils";

import { cn } from "@/lib/utils";

interface ScorecardScoreDeltaBadgeProps {
  drift?: number | null;
  className?: string;
}

const ScorecardScoreDeltaBadge = ({ drift, className }: ScorecardScoreDeltaBadgeProps) => {
  const label = formatScorecardDrift(drift);

  if (!label || typeof drift !== "number") {
    return null;
  }

  const isPositive = drift > 0;
  const Icon = isPositive ? ArrowUpRight : ArrowDownRight;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-0.5 text-sm font-semibold tabular-nums leading-none",
        isPositive ? "text-emerald-700" : "text-red-700",
        className,
      )}
      title={`${isPositive ? "Up" : "Down"} ${label.replace(/^[+-]\s*/, "")} from previous run`}
    >
      <Icon className="h-3.5 w-3.5 stroke-[2.25]" />
      <span>{label}</span>
    </span>
  );
};

export default ScorecardScoreDeltaBadge;
